import guangzhouPhoto from '../assets/guangzhou.jpg';
import chinaAvatarPhoto from '../assets/china-avatar.jpg';
import chinaMountainPhoto from '../assets/china-mountain.jpg';
import chongqingPhoto from '../assets/chongqing.jpg';
import greatWallPhoto from '../assets/great-wall.jpg';
import shanghaiPhoto from '../assets/shanghai.jpg';
import shenzhenPhoto from '../assets/shenzhen.jpg';
import hongKongPhoto from '../assets/hong-kong.jpg';

export const services = [
  {
    id: 'visa',
    label: 'Визы',
    title: 'Виза в Китай без лишней суеты',
    short: 'Анкета, приглашение, запись и сопровождение до результата.',
    image: guangzhouPhoto,
    details: [
      'Проверяем цель поездки и подбираем тип визы',
      'Собираем пакет документов без лишних справок',
      'Готовим приглашение и контролируем сроки',
      'Подсказываем по перелету, отелю и маршруту',
    ],
    accent: 'red',
  },
  {
    id: 'exhibitions',
    label: 'Китай',
    title: 'Поездки, выставки и бизнес-маршруты',
    short: 'Организация поездки в Китай от идеи до встречи на месте.',
    image: greatWallPhoto,
    details: [
      'Маршрут под выставки, деловые встречи или туризм',
      'Поддержка переводчика и локальной команды',
      'Бронирование, трансферы и контроль расписания',
      'Сопровождение во время поездки 24/7',
    ],
    accent: 'jade',
  },
  {
    id: 'tours',
    label: 'Туры',
    title: 'Авторские туры по Китаю',
    short: 'Индивидуальные маршруты, культурные программы и комфортное сопровождение по Китаю.',
    image: chinaMountainPhoto,
    details: [
      'Подбираем маршрут под ваши интересы и сроки',
      'Составляем программу по городам, кухням и достопримечательностям',
      'Организуем трансферы, проживание и локальную поддержку',
      'Сопровождаем на каждом этапе поездки',
    ],
    accent: 'green',
  },
  {
    id: 'business-visa',
    label: 'Бизнес',
    title: 'Бизнес-виза M/F и выставочные поездки',
    short: 'Подготовка для переговоров, выставок и деловых маршрутов в Китай.',
    image: chongqingPhoto,
    details: [
      'Помогаем подобрать тип визы под цель поездки',
      'Собираем приглашение и подтверждающие документы',
      'Организуем маршрут, встречи и программу на месте',
      'Поддержка до получения визы и в день поездки',
    ],
    accent: 'red',
  },
  {
    id: 'urgent',
    label: 'Срочно',
    title: 'Экспресс-оформление и сопровождение',
    short: 'Срочная подача, чек-листы и контроль сроков без стресса.',
    image: shenzhenPhoto,
    details: [
      'Срочная консультация по документам и срокам',
      'Проверка пакета перед подачей в консульство',
      'Контроль статуса на каждом этапе',
      'Решение вопросов по звонку, в мессенджере и лично',
    ],
    accent: 'jade',
  },
];

export const deskContent = {
  main: {
    kicker: 'Виза в Китай · Бишкек · Кыргызстан',
    title: 'Виза в Китай и поездки из Кыргызстана',
    description:
      'ChinaTao — команда в Бишкеке по оформлению виз в Китай, туристическим поездкам, бизнес-маршрутам, выставкам и сопровождению. Мы объясняем требования простыми словами, готовим документы и ведём каждый запрос до результата.',
    heroImage: guangzhouPhoto,
    stats: [
      ['3000+', 'виз оформлено'],
      ['98%', 'одобрений'],
      ['5 лет', 'на рынке'],
    ],
    trustItems: [
      'Официальный визовый агент',
      'Срочное оформление от 3 дней',
      'Гарантия возврата при отказе',
    ],
    route: ['Консультация', 'Подготовка документов', 'Подача и контроль', 'Получение визы'],
  },
};

export const companyStory = {
  title: 'О компании ChinaTao',
  intro:
    'Мы работаем не просто с визами, а с целыми маршрутами: от первого звонка и подбора типа визы до встречи в Китае и сопровождения на месте. Наша задача — сделать поездку понятной, предсказуемой и быстрой.',
  points: [
    'Работаем с туристическими, учебными, рабочими, семейными и бизнес-визами.',
    'Подбираем документы под конкретную цель поездки и условия консульства.',
    'Сопровождаем клиентов в Бишкеке и в Китае, включая выставки, туры и деловые поездки.',
    'Даем консультации на русском и кыргызском, поэтому процесс понятен без лишней бюрократии.',
  ],
  stats: [
    ['100%', 'комплексное сопровождение'],
    ['24/7', 'поддержка во время поездки'],
    ['50+', 'успешных маршрутов и визовых кейсов'],
  ],
};

export const visaTypes = [
  {
    code: 'L',
    title: 'Туристическая виза',
    summary: 'Для отдыха, туризма, посещения друзей и семейных поездок.',
    details:
      'Подходит для личных поездок в Китай: туризм, отдых, визиты к родственникам и друзьям. Оформляется индивидуально с персональным подбором документов и сроков.',
  },
  {
    code: 'L-G',
    title: 'Групповая туристическая виза',
    summary: 'Для тургрупп, семейных поездок и корпоративных поездок от 5 человек.',
    details:
      'Удобный вариант для групповых туров, семейных путешествий и корпоративных маршрутов. Помогаем организовать документы, сроки и подачу для всей группы.',
  },
  {
    code: 'M',
    title: 'Коммерческая виза',
    summary: 'Для переговоров, выставок и деловых контактов.',
    details:
      'Нужна, если цель поездки — бизнес-поездка, встречи с партнёрами, участие в форумах, выставках или заключение контрактов. Часто требует приглашение от китайской компании.',
  },
  {
    code: 'F',
    title: 'Виза для деловых и ознакомительных поездок',
    summary: 'Для конференций, визитов, обучения и обменных мероприятий.',
    details:
      'Подходит для деловых визитов, ознакомительных поездок, конференций, семинаров и встреч с партнёрами. Обычно оформляется на срок до нескольких месяцев в зависимости от приглашения.',
  },
  {
    code: 'X',
    title: 'Учебная виза',
    summary: 'Для поступления в вузы, языковые школы и образовательные программы.',
    details:
      'Подходит студентам, школьникам и участникам образовательных программ. Требует подтверждение учебы, приглашение от учебного заведения и дополнительные документы.',
  },
  {
    code: 'Z',
    title: 'Рабочая виза',
    summary: 'Для трудоустройства, работы по контракту и профессиональной деятельности.',
    details:
      'Нужна, если вы едете работать в Китай по трудовому договору, на проект, в компанию или на учебную/производственную базу. Пакет документов здесь самый полный и требует внимательной подготовки.',
  },
  {
    code: 'Q',
    title: 'Семейная виза',
    summary: 'Для воссоединения семьи и поездок к близким родственникам.',
    details:
      'Подходит тем, кто едет к супругу, детям, родителям или другим близким родственникам в Китай. Часто оформляется на длительный срок и требует подтверждение родства.',
  },
  {
    code: 'S',
    title: 'Виза для личных визитов',
    summary: 'Для длительных частных визитов и посещения родственников.',
    details:
      'Подходит для долгих личных поездок, когда важны визиты к родственникам или близким людям, проживающим в Китае. Обычно нужна более подробная доказательная база.',
  },
  {
    code: 'T',
    title: 'Транспортная виза',
    summary: 'Для водителей, перевозчиков и участников транспортных маршрутов.',
    details:
      'Подходит для рабочих и транспортных поездок через Китай, включая служебные маршруты, перевозки и командировки по линии транспорта.',
  },
];

export const extraServices = [
  {
    title: 'Сопровождение поездок',
    text: 'Помогаем с бронированием, маршрутами, встречами и подачей всех документов до вылета.',
    icon: '✈️',
  },
  {
    title: 'Выставки и деловые маршруты',
    text: 'Организуем участие в переговорах, выставках и деловых поездках, включая локальную поддержку в Китае.',
    icon: '🏢',
  },
  {
    title: 'Перевод и проверка документов',
    text: 'Проверяем анкеты, переводы, приглашения и дополнительные подтверждения перед подачей.',
    icon: '📄',
  },
  {
    title: 'Срочная визовая консультация',
    text: 'Быстро проверяем вашу ситуацию, документы и подсказываем лучший вариант подачи.',
    icon: '⚡',
  },
];

export const photoGallery = [
  guangzhouPhoto,
  chinaAvatarPhoto,
  chinaMountainPhoto,
  chongqingPhoto,
  greatWallPhoto,
  shanghaiPhoto,
  shenzhenPhoto,
  hongKongPhoto,
];

export const checkpoints = [
  'Быстрый аудит задачи',
  'Четкий план и сроки',
  'Документы и подача',
  'Сопровождение до результата',
];

export const marqueeItems = [
  'Визы в Китай',
  'Туры в Китай',
  'Бизнес-виза в Китай',
  'Выставки и маршруты',
  'Один менеджер',
  'Сопровождение 24/7',
];

export const proofPhoto = hongKongPhoto;